import { RautReportIndication } from 'features/indicationTriage'

/**
 * Extracts the scan number from an indication ID
 *
 * @param id - Indication ID (e.g., "S1", "S10")
 * @returns Scan number or undefined if not found
 */
export const extractScanNumber = (id: string): number | undefined => {
  const match = id.match(/S(\d+)/)
  return match ? parseInt(match[1], 10) : undefined
}

/**
 * Compares two indications for sorting based on their numeric suffix
 * For example: "S1", "S2", "S10" will be sorted correctly
 */
const compareIndications = (
  a: RautReportIndication,
  b: RautReportIndication
): number => {
  if (!a.title && !b.title) return 0
  if (!a.title) return 1
  if (!b.title) return -1

  const aNum = extractScanNumber(a.id)
  const bNum = extractScanNumber(b.id)

  if (aNum !== undefined && bNum !== undefined) {
    return aNum - bNum
  }
  return a.title.localeCompare(b.title)
}

/**
 * Sorts a list of indications by their scan number
 *
 * @param indications - Array of indications to sort
 * @returns Sorted array of indications
 */
export const sortIndicationsList = (
  indications: RautReportIndication[]
): RautReportIndication[] => {
  return indications.sort((a, b) => compareIndications(a, b))
}
